import { Button, InputAdornment, OutlinedInput, TextField, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import './SafalLeaderConfigMaster.css';
import { Helmet } from 'react-helmet-async';
import AddIcon from '@mui/icons-material/Add';
import { useLocation, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { useEffect, useState } from 'react';

import {
  getSafalLeaderConfigMaster,
  deleteSafalLeaderConfigMaster,
  getHelpVideoModule,
  getApplicationList,
  getSafalLeaderFrequencyConfig,
  getSignedURL,
  getSafalLeaderConfigMasterDownload,
} from '../../../services/Service';
import CustomButton from '../../../components/UI/CustomButton';
import DeleteConfirmationModal from './DeleteConfirmationModal';
import TableView from './TableView';
import AddSafalLeaderConfigMasterModal from './AddSafalLeaderConfigMasterModal';
import CustomMuiSelect from '../../../components/UI/CustomMuiSelect';
import DownloadMenu from './DownloadMenu';

const SafalLeaderConfigMaster = () => {
  const [addModalOpen, setAddModalOpen] = useState({
    open: false,
    data: null,
  });
  const [megaModuleList, setMegaModuleList] = useState([]);
  const [frequencyConfigList, setFrequencyConfigList] = useState([]);
  const [applicationsList, setApplicationsList] = useState([]);
  const [rawData, setRawData] = useState([]);
  const [rawDataFilter, setRawDataFilter] = useState([]);
  const [searchString, setSearchString] = useState('');
  const [selectString, setSelectString] = useState('');
  const [isDeleteConfirmationModalOpen, setIsDeleteConfirmationModalOpen] = useState({
    open: false,
    data: null,
  });

  const fetchData = async () => {
    try {
      const res = await getSafalLeaderConfigMaster();
      if (res.status === 200) {
        setRawData(res.data.data);
        if (selectString !== '') {
          const newFilter = res.data.data.filter((ex) => ex?.megaModule?.megaModule === selectString);
          setRawDataFilter(newFilter);
        } else {
          setRawDataFilter(res.data.data);
        }
      }
    } catch (err) {
      console.log('getFaqList fetchData error', err.message);
    }
  };

  const fetchMegaModuleData = async () => {
    try {
      const res = await getHelpVideoModule();
      if (res.status === 200) {
        setMegaModuleList(res.data.data);
      }
    } catch (err) {
      console.log('getFaqList fetchData error', err.message);
    }
  };
  const fetchApplicationsList = async () => {
    try {
      const res = await getApplicationList();
      if (res.status === 200) {
        setApplicationsList(res.data.data);
      }
    } catch (err) {
      console.log('getFaqList fetchData error', err.message);
    }
  };
  const fetchFrequencyConfigList = async () => {
    try {
      const res = await getSafalLeaderFrequencyConfig();
      if (res.status === 200) {
        setFrequencyConfigList(res.data.data);
      }
    } catch (err) {
      console.log('getFaqList fetchData error', err.message);
    }
  };

  const onAddModalOpen = () => {
    setAddModalOpen({
      open: true,
      data: null,
    });
  };
  const onAddModalOpenForEdit = (data) => {
    setAddModalOpen({
      open: true,
      data: data,
    });
  };
  const onAddModalClose = () => {
    setAddModalOpen({
      open: false,
      data: null,
    });
    fetchData();
  };

  const onDelete = async (data) => {
    try {
      const res = await deleteSafalLeaderConfigMaster(data._id);
      if (res.status === 200) {
        toast.success(res.data.message);
        onDeleteModalReset();
        fetchData();
      }
    } catch (err) {
      console.log(err);
      toast.error(err?.response?.data?.message || err.message);
    }
  };

  const onDeleteModalReset = () => {
    setIsDeleteConfirmationModalOpen({
      open: false,
      data: null,
    });
  };

  useEffect(() => {
    fetchData();
    fetchMegaModuleData();
    fetchApplicationsList();
    fetchFrequencyConfigList();
  }, []);

  // const onSearchChange = (e) => {
  //   setSelectString('');
  //   setSearchString(e.target.value);
  //   if (e.target.value === '') {
  //     setRawDataFilter(rawData);
  //   } else {
  //     const newFilter = rawData.filter((ex) => ex.question.toLowerCase().includes(e.target.value.toLowerCase()));
  //     setRawDataFilter(newFilter);
  //   }
  // };
  const onSelectChange = (e) => {
    setSelectString(e);
    // setSearchString('');
    if (e === '') {
      setRawDataFilter(rawData);
    } else {
      const newFilter = rawData.filter((ex) => ex?.megaModule?.megaModule === e);
      setRawDataFilter(newFilter);
    }
  };

  const downloadTrend = async (type) => {
    try {
      const res = await getSafalLeaderConfigMasterDownload({ application: 'SafalSubscriptions', fileType: type });
      const signedURLRes = await getSignedURL({
        url: res.data.url,
      });
      const link = document.createElement('a');
      link.href = signedURLRes.data;
      link.setAttribute('download', `file`);
      document.body.appendChild(link);
      link.click();

      toast.success('download successful');
    } catch (err) {
      const msg = err?.response?.data?.message || 'download failed, please try again';
      toast.error(msg);
    }
  };

  return (
    <>
      <Helmet>
        <title>SafalLeaderBoard Config Master - SafalSubscriptions</title>
      </Helmet>

      <div id="SafalLeaderConfigMaster">
        <div className="title-bar">
          <div className="title-search-div">
            <Typography variant="h4" sx={{ fontSize: '40px', fontWeight: 700, color: '#027c34' }}>
              SafalLeaderBoard Config Master
            </Typography>
          </div>
        </div>
        <div className="toggle-bar">
          <div className="toggle-bar-dix">
            <div style={{ width: '300px' }}>
              <CustomMuiSelect
                placeholder="Filter by Mega Module"
                value={selectString}
                onChange={(e) => onSelectChange(e?.label || '')}
                options={megaModuleList?.map((e) => ({ label: e?.megaModule }))}
                size="small"
                variant="outlined"
              />
            </div>

            {/* <TextField
              sx={{ width: '200px', ml: '12px' }}
              onChange={onSearchChange}
              value={searchString}
              type="search"
              id="search-input"
              size="small"
              label="Search"
              variant="outlined"
            /> */}
          </div>
          <div className="title-action-div">
            <DownloadMenu downloadFile={downloadTrend} />
            <CustomButton backgroundColor="#027c34" text="Add New" icon={<AddIcon />} onClick={onAddModalOpen} />
          </div>
        </div>
        <TableView
          onDelete={(data) => {
            setIsDeleteConfirmationModalOpen({
              open: true,
              data,
            });
          }}
          onEdit={onAddModalOpenForEdit}
          data={rawDataFilter}
        />
      </div>
      <DeleteConfirmationModal
        open={isDeleteConfirmationModalOpen.open}
        onClose={onDeleteModalReset}
        data={isDeleteConfirmationModalOpen.data}
        onSubmit={onDelete}
      />
      <AddSafalLeaderConfigMasterModal
        frequencyConfigList={frequencyConfigList}
        applicationsList={applicationsList}
        megaModuleList={megaModuleList}
        open={addModalOpen.open}
        data={addModalOpen.data}
        onClose={onAddModalClose}
      />
    </>
  );
};

export default SafalLeaderConfigMaster;
